import { render } from "./ProofreadingActions.vue?vue&type=template&id=7ae9bccf&scoped=true&ts=true"
import script from "./ProofreadingActions.vue?vue&type=script&lang=ts"
export * from "./ProofreadingActions.vue?vue&type=script&lang=ts"

import "./ProofreadingActions.vue?vue&type=style&index=0&id=7ae9bccf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae9bccf"]])

export default __exports__